import PropTypes from 'prop-types';

import BaseChip from '../BaseChip';

const Tag = ({
  size = null,
  isDarkMode = false,
  isOverlay = false,
  colorSchema,
  ...props
}) => (
  <BaseChip
    size={size || 'small'}
    colorSchema={BaseChip.SCHEMAS[colorSchema] || BaseChip.SCHEMAS.tag}
    isDarkMode={isDarkMode}
    isOverlay={isOverlay}
    {...props}
  />
);

export default Tag;

Tag.propTypes = {
  ...BaseChip.propTypes,
  isDarkMode: PropTypes.bool,
  isOverlay: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
};
